var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.edit ? "编辑日程" : "新增日程",
            visible: _vm.drawer,
            wrapperClosable: false,
            size: "600px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { ref: "scrollRef", staticClass: "box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "待办标题：", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { size: "small", placeholder: "请输入待办标题" },
                        model: {
                          value: _vm.ruleForm.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "title", $$v)
                          },
                          expression: "ruleForm.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.cid !== 5
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "15px" },
                          attrs: { label: "参与人：", prop: "member" },
                        },
                        [
                          _c("select-member", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              value: _vm.superiorUser,
                              "is-avatar": true,
                            },
                            on: { getSelectList: _vm.getSelectList },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "开始时间：", prop: "start_time" } },
                    [
                      _c(
                        "div",
                        { staticClass: "start-time" },
                        [
                          _c("el-date-picker", {
                            style: {
                              width: _vm.ruleForm.all_day ? "85%" : "190px",
                            },
                            attrs: {
                              size: "small",
                              type: "date",
                              clearable: false,
                              placeholder: "选择日期",
                              format: "yyyy-MM-dd",
                              "validate-event": false,
                            },
                            on: { change: _vm.durationTypeFn },
                            model: {
                              value: _vm.startDate,
                              callback: function ($$v) {
                                _vm.startDate = $$v
                              },
                              expression: "startDate",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.ruleForm.all_day
                            ? _c("el-time-picker", {
                                staticStyle: { width: "190px" },
                                attrs: {
                                  size: "small",
                                  clearable: false,
                                  placeholder: "选择时间",
                                  "value-format": "HH:mm:ss",
                                  "validate-event": false,
                                },
                                on: { change: _vm.durationTypeFn },
                                model: {
                                  value: _vm.startTime,
                                  callback: function ($$v) {
                                    _vm.startTime = $$v
                                  },
                                  expression: "startTime",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.allDayFn },
                              model: {
                                value: _vm.ruleForm.all_day,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "all_day", $$v)
                                },
                                expression: "ruleForm.all_day",
                              },
                            },
                            [_vm._v("全天")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.ruleForm.all_day && !_vm.edit
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "时长：", prop: "" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { size: "small", placeholder: "请选择" },
                              on: { change: _vm.durationTypeFn },
                              model: {
                                value: _vm.durationType,
                                callback: function ($$v) {
                                  _vm.durationType = $$v
                                },
                                expression: "durationType",
                              },
                            },
                            _vm._l(_vm.durationList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.durationType == 5 || _vm.ruleForm.all_day
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "结束时间：", prop: "end_time" } },
                        [
                          _c(
                            "div",
                            { staticClass: "end-time" },
                            [
                              _c("el-date-picker", {
                                style: {
                                  width: _vm.ruleForm.all_day ? "85%" : "190px",
                                },
                                attrs: {
                                  size: "small",
                                  type: "date",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                  clearable: false,
                                  placeholder: "选择日期",
                                  "validate-event": false,
                                },
                                model: {
                                  value: _vm.endDate,
                                  callback: function ($$v) {
                                    _vm.endDate = $$v
                                  },
                                  expression: "endDate",
                                },
                              }),
                              _vm._v(" "),
                              !_vm.ruleForm.all_day
                                ? _c("el-time-picker", {
                                    staticStyle: { width: "190px" },
                                    attrs: {
                                      size: "small",
                                      "value-format": "HH:mm:ss",
                                      clearable: false,
                                      placeholder: "选择时间",
                                      "validate-event": false,
                                    },
                                    model: {
                                      value: _vm.endTime,
                                      callback: function ($$v) {
                                        _vm.endTime = $$v
                                      },
                                      expression: "endTime",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "addWidth" }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "提醒时间：", prop: "remind" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { size: "small", placeholder: "请选择" },
                          model: {
                            value: _vm.ruleForm.remind,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "remind", $$v)
                            },
                            expression: "ruleForm.remind",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "重复：", prop: "period" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { size: "small", placeholder: "请选择" },
                          on: { change: _vm.daysChange },
                          model: {
                            value: _vm.ruleForm.period,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "period", $$v)
                            },
                            expression: "ruleForm.period",
                          },
                        },
                        _vm._l(_vm.repeatOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.period == 1 || _vm.ruleForm.period == 4
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "rate", label: "频率:" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              size: "small",
                              controls: false,
                              min: 1,
                              placeholder: _vm.$t("calendar.placeholder17"),
                            },
                            model: {
                              value: _vm.ruleForm.rate,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "rate", $$v)
                              },
                              expression: "ruleForm.rate",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.ruleForm.period == 1 ? "天" : "年")
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.period == 2
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "days", label: "每周:" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.ruleForm.days,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "days", $$v)
                                },
                                expression: "ruleForm.days",
                              },
                            },
                            _vm._l(_vm.week, function (item) {
                              return _c(
                                "el-checkbox-button",
                                {
                                  key: item.value,
                                  attrs: { label: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.period == 3
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "month",
                          attrs: { prop: "days", label: "每月:" },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.ruleForm.days,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "days", $$v)
                                },
                                expression: "ruleForm.days",
                              },
                            },
                            _vm._l(31, function (item) {
                              return _c(
                                "el-checkbox-button",
                                {
                                  key: item,
                                  attrs: { label: item.toString() },
                                },
                                [_vm._v(_vm._s(item < 10 ? "0" + item : item))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.period != 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "重复截至日期:" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              size: "small",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              "prefix-icon": "el-icon-date",
                              clearable: true,
                              placeholder: _vm.$t("calendar.neverend"),
                            },
                            model: {
                              value: _vm.ruleForm.fail_time,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "fail_time", $$v)
                              },
                              expression: "ruleForm.fail_time",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "日程类型：", prop: "cid" } },
                    [
                      _vm.ruleForm.type && _vm.ruleForm.cid < 7
                        ? _c("div", [_vm._v(_vm._s(_vm.cidName))])
                        : _c(
                            "div",
                            { staticClass: "start-time" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "small",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.cidChangeFn },
                                  model: {
                                    value: _vm.ruleForm.cid,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "cid", $$v)
                                    },
                                    expression: "ruleForm.cid",
                                  },
                                },
                                _vm._l(_vm.tableData, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "colorBox",
                                style: { backgroundColor: _vm.backgroundColor },
                              }),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      !_vm.edit
                        ? _c("span", { staticClass: "prompt" }, [
                            _vm._v(
                              " 客户跟进、续费提醒、回款提醒、汇报待办，请去对应业务处进行添加"
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.drawer
                    ? _c("ueditorFrom", {
                        ref: "ueditorFrom",
                        tag: "component",
                        attrs: {
                          border: true,
                          height: "400px",
                          type: "simple",
                          content: _vm.ruleForm.content,
                        },
                        on: { input: _vm.ueditorEdit },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "button from-foot-btn fix btn-shadow" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.loading,
                        size: "small",
                      },
                      on: { click: _vm.submitForm },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }